<template>
  <section class="invoice-add-wrapper">
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(addUpdateDepartmentAction)"
        @reset.prevent="resetForm"
        v-if="departmentData != null"
      >
        <b-row style="margin-bottom: 20px">
          <b-col cols="4">
            <h6
              class="section-label text-primary float-left"
              style="
                border-right: 5px solid orange;
                border-bottom: 1px solid orange;
                border-radius: 0px 50px 0px 0px;
                font-size: 18px;
                padding-right: 10px;
                top: 1px;
                width: auto;
              "
            >
              <feather-icon icon="FileAddIcon" size="25" />
              {{ operationTitle }} Module
            </h6>
          </b-col>
          <b-col cols="8">
            <b-button
              v-if="$router.name == 'department-view'"
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'department-view',
                  params: { id: departmentData.id + 1 },
                })
              "
            >
              <span class="d-none d-sm-inline">Suiv.</span>
              <feather-icon icon="ChevronRightIcon" size="12" />
            </b-button>
            <b-button
              v-if="$router.name == 'department-view'"
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'department-view',
                  params: { id: departmentData.id - 1 },
                })
              "
            >
              <feather-icon icon="ChevronLeftIcon" size="12" />
              <span class="d-none d-sm-inline">Préc.</span>
            </b-button>

            <b-button
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'department-list',
                })
              "
            >
              <feather-icon icon="ListIcon" size="12" />
              <span class="d-none d-sm-inline">Liste des Modules</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row class="invoice-add">
          <!-- Col: Left (Invoice Container) -->
          <b-col cols="12" xl="12" md="12">
            <b-card no-body class="invoice-preview-card">
              <b-row class="">
                <!-- Name -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="validationContext"
                    name="name"
                    rules="required"
                  >
                    <b-form-group label="Nom du module" label-for="name">
                      <b-form-input
                        id="name"
                        v-model="departmentData.name"
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Ex: Ressources Humaines"
                        class=""
                      />
                      <b-form-invalid-feedback>
                        Completer le nom du module
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="3">
                  <validation-provider
                    #default="validationContext"
                    name="route"
                  >
                    <b-form-group label="Adresse" label-for="route">
                      <b-form-input
                        id="route"
                        v-model="departmentData.route"
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Ex: administration . :readonly=editableRoute"
                        class=""
                      />
                      <b-form-invalid-feedback>
                        Completer le lien s'il vous plait
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="3">
                  <validation-provider #default="validationContext" name="icon">
                    <b-form-group label="Icone" label-for="icon">
                      <b-form-input
                        id="icon"
                        v-model="departmentData.icon"
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Ex: PlusIcon"
                        class=""
                      />
                      <b-form-invalid-feedback>
                        Completer l'icone s'il vous plait
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row
                class="pb-2"
                v-for="(module, s_index) in departmentData.modules"
                :key="s_index"
                ref="row"
              >
                <b-col cols="12" md="3">
                  <validation-provider
                    #default="validationContext"
                    :name="'name.module.' + s_index"
                    rules="required"
                  >
                    <b-form-group :label-for="'name.module.' + s_index"
                      ><label
                        ><span class="text-primary"
                          >{{ s_index + 1 }}e<span v-if="s_index == 0">r</span>
                          Menu</span
                        >
                        (Nom / Designation)</label
                      >
                      <b-form-input
                        :id="'name.module.' + s_index"
                        v-model="departmentData.modules[s_index].name"
                        :state="getValidationState(validationContext)"
                        trim
                        :placeholder="'Ex: Gérer le personnel,...'"
                      />
                      <b-form-invalid-feedback>
                        Completer du menu {{ s_index + 1 }} s'il vous plait
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="3">
                  <validation-provider
                    #default="validationContext"
                    name="route"
                  >
                    <b-form-group label="Adresse" label-for="route">
                      <b-form-input
                        :id="'route.module.' + s_index"
                        v-model="departmentData.modules[s_index].route"
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Ex: personnel,..."
                        class=""
                        readonly="readonly"
                      />

                      <!-- :readonly="`{{ editableRoute }}`" -->

                      <b-form-invalid-feedback>
                        Completer le lien s'il vous plait
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col cols="12" md="3">
                  <validation-provider #default="validationContext" name="icon">
                    <b-form-group label="Icone" label-for="icon">
                      <b-form-input
                        :id="'icon.module.' + s_index"
                        v-model="departmentData.modules[s_index].icon"
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Ex: PlusIcon"
                        class=""
                        value="PlusIcon"
                      />
                      <b-form-invalid-feedback>
                        Completer l'icone s'il vous plait
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- <b-col cols="12" md="3">
                  <b-form-group label="Sous-Dossier" label-for="folder">
                    <b-form-checkbox
                      :id="'folder.module.' + s_index"
                      v-model="departmentData.modules[s_index].folder"
                    ></b-form-checkbox>
                  </b-form-group>
                </b-col> -->
              </b-row>

              <b-row style="margin-top: 5px"
              v-if="$router.name == 'department-add'"
              >
                <b-col cols="12" md="4">
                  <b-button
                    variant="outline-primary"
                    class="btn-sm float-left"
                    @click="addNewStepForm"
                  >
                    <feather-icon icon="PlusIcon" size="12" />
                    <span class="xl-none">Ajouter un Menu</span>
                  </b-button>
                </b-col>
              </b-row>

              <!-- Spacer -->
              <hr class="invoice-spacing" v-if="showed == true" />
            </b-card>
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 20px" v-if="showed == true">
          <b-col cols="12">
            <b-button
              ref="refSubmitEl"
              type="submit"
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              <feather-icon icon="SaveIcon" v-if="loading == false" size="19" />

              {{ actionName }}
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
              @click="reinitForm"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-row style="margin-bottom: 20px" v-if="departmentData == null">
      <b-col cols="12">
        <h1>Chargement des données en cours...</h1>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import axios from "axios";
import { $themeConfig } from "@themeConfig";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import store from "@/store";
import { required, integer } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
// sweet alert
import { codeBasic } from "../../extensions/sweet-alert/code";
// alerts
import SweetAlertBasic from "../../extensions/sweet-alert/SweetAlertBasic.vue";
import SweetAlertPosition from "../../extensions/sweet-alert/SweetAlertPosition.vue";
import SweetAlertAnimation from "../../extensions/sweet-alert/SweetAlertAnimation.vue";
import SweetAlertTypes from "../../extensions/sweet-alert/SweetAlertTypes.vue";
import SweetAlertOption from "../../extensions/sweet-alert/SweetAlertOption.vue";
import SweetAlertConfirmOption from "../../extensions/sweet-alert/SweetAlertConfirmOption.vue";
// notifications
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"; 
import ToastificationVariant from "../../extensions/toastification/ToastificationVariant.vue";
import ToastificationPosition from "../../extensions/toastification/ToastificationPosition.vue";
import ToastificationIcon from "../../extensions/toastification/ToastificationIcon.vue";
import ToastificationTimeout from "../../extensions/toastification/ToastificationTimeout.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,

  // Form Validation
  BFormInvalidFeedback,
} from "bootstrap-vue";

import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import invoiceStoreModule from "./storeModule";
import router from "@/router";

const moduleName = "department";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    // alerts
    SweetAlertBasic,
    SweetAlertPosition,
    SweetAlertAnimation,
    SweetAlertTypes,
    SweetAlertOption,
    SweetAlertConfirmOption,
    // notification
    ToastificationVariant,
    ToastificationPosition,
    ToastificationIcon,
    ToastificationTimeout,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
      actionName: "",
      imageActionText: "",
      actionIndex: 0,
      reduction: 0,
      subTotal: 0,
      total: 0,
      currency: "$US",
      showed: true,
      loading: false,
      editableRoute: false,
    };
  },
  props: {
    departmentData: {
      type: Object,
    },
    moduleformblankData: {
      type: Object,
    },
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [heightTransition],
  mounted() {
    // console
    if (router.currentRoute.name == "department-add-new") {
      this.operationTitle = "Nouveau ";
      this.operationIcon = "AddIcon";
      this.editableRoute = true;
    }
    if (router.currentRoute.name == "department-view") {
      this.operationTitle = "Détails du ";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "department-edit") {
      this.operationTitle = "Modification du ";
      this.operationIcon = "EditIcon";
    }

    if (router.currentRoute.name == moduleName + "-add-new") {
      this.actionName = "Enregistrer ";
      this.imageActionText = "Ajouter Image";
      this.actionIndex = 1;
      this.showed = true;

      //
      // empty values
      this.$props.departmentData.modules = [];
      //
      this.$props.departmentData.modules.push(
        JSON.parse(JSON.stringify(this.$props.moduleformblankData))
      );
    }
    if (router.currentRoute.name == moduleName + "-view") {
      this.actionName = "Visionner";
      this.imageActionText = "?";
      this.actionIndex = 2;
      this.showed = false;
    }
    if (router.currentRoute.name == moduleName + "-edit") {
      this.actionName = "Enregistrer Modifications";
      this.imageActionText = "Modifier Image";
      this.actionIndex = 3;
      this.showed = true;
    }

    // console.log(this.$refs);
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    reinitForm() {
      var now = new Date();
      //
      this.$props.departmentData.sku_department_parent = "";
      this.$props.departmentData.sku_department = "department-" + now.getTime();
      this.$props.departmentData.name = "";
      this.$props.departmentData.route = "";
      this.$props.departmentData.icon = "";
      // remove all occurences
      this.$props.departmentData.modules = [];
      // initialise 1 element
      this.$props.departmentData.modules.push(
        JSON.parse(JSON.stringify(this.$props.moduleformblankData))
      );
      // update row heigth
      this.initTrHeight();
    },

    async addUpdateDepartmentAction() {
      // ---------------------------
      let formData = new FormData();
      // ---------------------------
      const defaultActionText = this.actionName;

      let method = "";
      let params = "";

      if (router.currentRoute.name == "department-add-new") {
        this.actionName = "Enregistrement...";
        method = "post";
      }
      if (router.currentRoute.name == "department-view") {
        method = "get";
      }
      if (router.currentRoute.name == "department-edit") {
        this.actionName = "Modification...";
        method = "put";
        params = "/" + this.departmentData.id;
      }

      // finalise form data
      formData = this.$props.departmentData;

      myApi({
        url: "department" + params,
        method: method,
        data: formData,
      })
        .then((response) => {
          // default action
          this.actionName = defaultActionText;

          if (response.status == 200 || response.status == 201) {
            this.$swal({
              title: "Fin de l'opération",
              text: response.data.message,
              icon: "success",
              timer: 5000,
              showCancelButton: true,
              confirmButtonText: "Afficher Formulaire Vide",
              cancelButtonText: "Afficher Liste ?",
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-outline-primary ml-1",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.value) {
                // stay here
                // reinit form
                this.reinitForm();
              } else if (result.dismiss === "cancel") {
                // redirection to list
                router.push({ name: "department-list" });
              }
            });
          } else {
            this.actionName = defaultActionText;
            this.errors.push(response.data.message);
            this.showToast(
              "Erreur Survenu",
              response.data.message,
              "warning",
              "BellIcon",
              "top-center",
              4000
            );
          }
        })
        .catch((error) => {
          this.actionName = defaultActionText;
          this.showToast(
            "Erreur Exceptionnelle Survenu",
            error.response.data.message,
            "warning",
            "AlertTriangleIcon",
            "top-center",
            5000
          );
        });
    },
    checkFormInputs() {
      var errors = 0;
      for (const [s_key, s_value] of Object.entries(
        this.$props.departmentData.modules
      )) {
        // modules
        for (const [i_key, i_value] of Object.entries(
          this.$props.departmentData.modules[s_key].items
        )) {
          // items
          // console.log(i_value);

          if (i_value.name.name.length > 0) {
            // value is not null
          } else {
            errors++;
          }
        }
      }
      if (errors > 0) {
        return false;
      } else {
        return true;
      }
    },
    goToPrecDepartment() {
      router.push({ name: "department-view" });
    },
    goToNextDepartment() {
      router.push({ name: "department-list" });
    },
    goToList() {
      router.push({ name: "department-list" });
    },
    addNewStepForm() {
      ////////////////////////////////////////////////////////
      // this.$refs.form[0].style.overflow = "hidden";
      this.$props.departmentData.modules.push(
        JSON.parse(JSON.stringify(this.$props.moduleformblankData))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          // this.$refs.form[0].style.overflow = null;
        }, 350);
      });
    },
    addNewDepartmentInDepartmentForm(module_index) {
      // this.$refs.form[0].style.overflow = "hidden";
      this.$props.departmentData.modules[module_index].items.push(
        JSON.parse(JSON.stringify(this.$props.itemformblankData))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          // this.$refs.form[0].style.overflow = null;
        }, 350);
      });
    },
    updateDepartmentForm(s_index, index, val) {
      const { cost, qty, buy_unit, description } = val;
      // ---------------------------------------------------------
      this.$props.departmentData.modules[s_index].items[index].cost = cost;
      this.$props.departmentData.modules[s_index].items[index].qty_unit =
        buy_unit;
      if (
        this.$props.departmentData.modules[s_index].items[index].qty == null ||
        this.$props.departmentData.modules[s_index].items[index].qty ==
          undefined
      ) {
        // default qty
        this.$props.departmentData.modules[s_index].items[index].qty = 1;
      }
      this.$props.departmentData.modules[s_index].items[index].description =
        description;
    },
    removeDepartment(s_index, index) {
      this.$props.departmentData.modules[s_index].items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        // this.trSetHeight(this.$refs.form[0].scrollHeight);
      });
    },
    // alert
    alertAutoClose(header, message, seconds, cssClass) {
      this.$swal({
        title: header,
        html: message,
        timer: seconds,
        customClass: {
          confirmButton: cssClass,
        },
        buttonsStyling: false,
      });
      // "btn btn-primary",
    },
    // notification
    showToast(header, message, variant, icon, position, timeout) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: header,
            icon,
            text: message,
            variant,
          },
        },
        {
          position,
          timeout,
        }
      );
    },
  },
  setup() {
    //////////////////////////////////////////////////////////////////////////
    const INVOICE_APP_STORE_MODULE_NAME = "app-department";

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME);
    });

    let resetmoduleData = () => {
      this.$props.departmentData = this.$props.moduleData;
    };

    let { refFormObserver, getValidationState, resetForm } =
      formValidation(resetmoduleData);
    //
    // let itemsList = ref([]);
    // store.dispatch("app-department/fetchDepartments").then((response) => {
    //   itemsList.value = response.data;
    //   // itemsList = response.data;
    // });

    // // fill items
    // let itemsOptions = itemsList;

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
